import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getUpdateRemoveChatModalState, setUpdateRemoveChatModal } from '../../../store/slices/chatsSlice';
import CreateNewChat, { createChatBtnType } from '../CreateNewChat';
import Modal from '../Modal';
import styles from './styles.module.scss';

const UpdateRemoveChatModal = () => {
    const { t } = useTranslation();
    const { isOpen, alias } = useSelector(getUpdateRemoveChatModalState);
    const dispatch = useDispatch();
    const onClose = () => {
        dispatch(setUpdateRemoveChatModal({ isOpen: false, alias: null }));
    };

    useEffect(() => {
        return () => {
            dispatch(setUpdateRemoveChatModal({ isOpen: false, alias: null }));
        };
    }, []);

    return (
        <>
            {isOpen ? (
                <Modal onCloseClick={onClose}>
                    <h3 className={styles.title}>{t('pages.chat.wasRemoved')}</h3>
                    <p className={styles.subtitle}>{t('pages.chat.wasRemovedRequest')}</p>
                    <div className={styles.buttons}>
                        <button className={styles.cancelBtn} onClick={onClose}>
                            {t('pages.chat.toMarketplace')}
                        </button>
                        <div className={styles.confirmBtn}>
                            {!!alias && (
                                <CreateNewChat
                                    advisorAlias={alias}
                                    type={createChatBtnType.advisorLanding}
                                    label={t('pages.chat.createChat', { alias: alias })}
                                />
                            )}
                        </div>
                    </div>
                </Modal>
            ) : null}
        </>
    );
};
export default UpdateRemoveChatModal;
